import { createFileRoute, redirect } from '@tanstack/react-router';

/** Scanners and GET navigation cannot decline an invitation. */
export const Route = createFileRoute('/invites/$token_/decline')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/invites/$token', params: { token: params.token } });
  },
});
